/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedBlurbLeadTime_item$ref = any;
type PdpSharedBlurbReturns_item$ref = any;
type PdpSharedBlurbShipping_item$ref = any;
type PdpSharedBlurbSupportNumber_item$ref = any;
type PdpSharedBlurbUrgency_item$ref = any;
export type PdpRespSidebarBlurbs_item$ref = any;
export type PdpRespSidebarBlurbs_item = {
    readonly isJewelry?: boolean | null;
    readonly getCategoriesByLevel?: ReadonlyArray<{
        readonly label: string | null;
    } | null> | null;
    readonly pricing?: {
        readonly totalAmount: {
            readonly convertedAmounts: {
                readonly USD: number | null;
            } | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": PdpSharedBlurbLeadTime_item$ref & PdpSharedBlurbReturns_item$ref & PdpSharedBlurbShipping_item$ref & PdpSharedBlurbUrgency_item$ref & PdpSharedBlurbSupportNumber_item$ref;
    readonly " $refType": PdpRespSidebarBlurbs_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSidebarBlurbs_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedBlurbLeadTime_item",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedBlurbReturns_item",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedBlurbShipping_item",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedBlurbUrgency_item",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedBlurbSupportNumber_item",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": false,
            "condition": "isTrade",
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isJewelry",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "getCategoriesByLevel",
                    "storageKey": "getCategoriesByLevel(level:2)",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "level",
                            "value": 2
                        }
                    ],
                    "concreteType": "Category",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "label",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pricing",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemPricing",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "totalAmount",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "convertedAmounts",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ConvertedAmounts",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "USD",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '021a83e57bc5b8461f01ef06998e2ef0';
export default node;
